import React from "react";
import PropTypes from "prop-types";
import styles from "./ButtonStyledRadioButtonGroup.module.css";

import ButtonStyledRadioButton from "../ButtonStyledRadioButton";

/**
 * Interactive component.
 * A radio button group using radio buttons styles as buttons.
 */
export function ButtonStyledRadioButtonGroup({
  currentlySelected,
  setCurrentlySelected,
  options,
}) {
  return (
    <fieldset className={styles.group}>
      {options.map((option) => (
        <ButtonStyledRadioButton
          key={option.value}
          isSelected={currentlySelected === option.value}
          setCurrentlySelected={setCurrentlySelected}
          {...option}
        />
      ))}
    </fieldset>
  );
}

ButtonStyledRadioButtonGroup.propTypes = {
  /**
   * The value of the currently selected radio button.
   */
  currentlySelected: PropTypes.string,
  /**
   * Function that fires when the currently selected radio button changes.
   */
  setCurrentlySelected: PropTypes.func,
  /**
   * An array of the radio button values with the button content.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    })
  ),
};

ButtonStyledRadioButtonGroup.defaultProps = {
  options: [],
};
